import { DndContext, DragMoveEvent, DragStartEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { useContext, useRef } from 'react'
import { Range } from 'types'
import { RangeSliderWithoutContext } from 'ui'
import { UGEContext } from '../../../../context'
import { UGELayer } from '../../../../types'
import { Icon, NoDuration, Thumbnail, Time, Title } from './style'

type Props = {
    className?: string
    dragging?: boolean
    layer: UGELayer
    open?: boolean
}

const UGELayersEditorLayerHeader = ({ className, dragging = false, layer, open = false }: Props) => {
    const pausedRef = useRef<boolean>(false)
    const { duration, paused, scrub, updateLayerById, setPaused } = useContext(UGEContext)
    const pointerSensor = useSensor(PointerSensor)
    const sensors = useSensors(pointerSensor)
    const { timing } = layer.props

    function getLabel() {
        return (
            <>
                {layer.thumbnailUrl && <Thumbnail src={layer.thumbnailUrl} alt="" />}
                <Title layer={layer} />
                <Icon layer={layer} />
            </>
        )
    }

    function onRangeChange(value: Range) {
        updateLayerById(layer.id, { timing: value })
    }

    function onDragMove(e: DragMoveEvent | DragStartEvent) {
        if (!e.active.data.current) return

        const { controlType, controlValue } = e.active.data.current

        switch (controlType) {
            case 'range-end':
                scrub((controlValue as Range).end)
                break
            case 'range-start':
                scrub((controlValue as Range).start)
                break
            case 'playhead':
                break
        }
    }

    function onDragEnd() {
        setPaused(pausedRef.current)
    }

    function onDragStart(e: DragStartEvent) {
        pausedRef.current = paused
        setPaused(true)
        onDragMove(e)
    }

    if (!duration) {
        return <NoDuration>{getLabel()}</NoDuration>
    }

    return (
        <DndContext sensors={sensors} onDragEnd={onDragEnd} onDragMove={onDragMove} onDragStart={onDragStart}>
            <RangeSliderWithoutContext
                className={className}
                gradient={open || dragging ? 'indigo-blue' : undefined}
                range={timing}
                size="medium"
                onChange={onRangeChange}
            >
                {getLabel()}
                <Time duration={duration} layer={layer} />
            </RangeSliderWithoutContext>
        </DndContext>
    )
}

export default UGELayersEditorLayerHeader
